import { ChevronDown } from 'lucide-react';
import type { Key } from 'react';
import { Badge, BadgeColor } from './Badge';
import { PopSearch } from './PopSearch';

type Status<T> = {
  value: T;
  label: string;
  color?: BadgeColor;
};

interface BadgeSelectProps<T extends Key> {
  value: T | null;
  onChange: (value: Status<T> | null) => void;
  options: Status<T>[];
}

export function BadgeSelect<T extends Key>(props: BadgeSelectProps<T>) {
  const { value, onChange, options } = props;
  return (
    <PopSearch
      value={value}
      onChange={onChange}
      options={options}
      valueAccessor={(option) => option.value}
      labelAccessor={(option) => option.label}
      itemOverride={(option) => <Badge color={option.color}>{option.label}</Badge>}
      trigger={(trigger, selectedOption) => (
        <Badge asChild className="cursor-pointer min-w-16 min-h-6" color={selectedOption?.color}>
          <button type="button" onClick={trigger}>
            {selectedOption ? selectedOption.label : '+ Choisir un statut'}{' '}
            <ChevronDown className="size-2" />
          </button>
        </Badge>
      )}
      placeholder="Changer le statut..."
    />
  );
}
